import { render, staticRenderFns } from "./ReferenceMaterialModal.vue?vue&type=template&id=0fd5abd0&"
import script from "./ReferenceMaterialModal.vue?vue&type=script&lang=js&"
export * from "./ReferenceMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceMaterialModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports